import Api from './base';
import fetch from 'isomorphic-fetch';

export default class AudioApi extends Api {
  createClipp(fileName, fileType, fileSize, userId) {
    return this.request(
      'POST',
      `${this.baseUrl}/api/1.0/audio`,
      { fileName, fileType, fileSize, userId },
      this.headers
    );
  }

  uploadAudioFile(file, oneTimeUrl) {
    return fetch(oneTimeUrl, {
      method: 'PUT',
      body: file,
    }).then(response => {
      console.log(response);
    });
  }

  loadAudioFile(audioId, audioType) {
    return this.request('GET', `${this.baseUrl}/api/1.0/audio/${audioId}?audioType=${audioType}`, null, this.headers);
  }

  // TODO: Deprecated
  getOneTimeUploadUrl(fileName, fileType, fileSize) {
    return this.request('POST', `${this.baseUrl}/api/1.0/generateUrl`, { fileName, fileType, fileSize }, this.headers);
  }

  getAudioBlob(episodeUrl) {
    return fetch(episodeUrl);
  }
}
